import { render, staticRenderFns } from "./ServiceAppoint.vue?vue&type=template&id=25e0c2f4&scoped=true&"
import script from "./ServiceAppoint.vue?vue&type=script&lang=ts&"
export * from "./ServiceAppoint.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceAppoint.vue?vue&type=style&index=0&id=25e0c2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e0c2f4",
  null
  
)

export default component.exports